/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanEntitlementUpdateRequest } from './PlanEntitlementUpdateRequest';
import {
    PlanEntitlementUpdateRequestFromJSON,
    PlanEntitlementUpdateRequestFromJSONTyped,
    PlanEntitlementUpdateRequestToJSON,
    PlanEntitlementUpdateRequestToJSONTyped,
} from './PlanEntitlementUpdateRequest';

/**
 * 
 * @export
 * @interface PlanUpdateRequest
 */
export interface PlanUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PlanUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PlanUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PlanUpdateRequest
     */
    tierRank?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PlanUpdateRequest
     */
    billingInterval: string;
    /**
     * 
     * @type {number}
     * @memberof PlanUpdateRequest
     */
    priceCents?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PlanUpdateRequest
     */
    currency: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlanUpdateRequest
     */
    selfServiceSelectable?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlanUpdateRequest
     */
    active?: boolean | null;
    /**
     * 
     * @type {Array<PlanEntitlementUpdateRequest>}
     * @memberof PlanUpdateRequest
     */
    entitlements?: Array<PlanEntitlementUpdateRequest> | null;
}

/**
 * Check if a given object implements the PlanUpdateRequest interface.
 */
export function instanceOfPlanUpdateRequest(value: object): value is PlanUpdateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('billingInterval' in value) || value['billingInterval'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function PlanUpdateRequestFromJSON(json: any): PlanUpdateRequest {
    return PlanUpdateRequestFromJSONTyped(json, false);
}

export function PlanUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'tierRank': json['tierRank'] == null ? undefined : json['tierRank'],
        'billingInterval': json['billingInterval'],
        'priceCents': json['priceCents'] == null ? undefined : json['priceCents'],
        'currency': json['currency'],
        'selfServiceSelectable': json['selfServiceSelectable'] == null ? undefined : json['selfServiceSelectable'],
        'active': json['active'] == null ? undefined : json['active'],
        'entitlements': json['entitlements'] == null ? undefined : ((json['entitlements'] as Array<any>).map(PlanEntitlementUpdateRequestFromJSON)),
    };
}

export function PlanUpdateRequestToJSON(json: any): PlanUpdateRequest {
    return PlanUpdateRequestToJSONTyped(json, false);
}

export function PlanUpdateRequestToJSONTyped(value?: PlanUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'tierRank': value['tierRank'],
        'billingInterval': value['billingInterval'],
        'priceCents': value['priceCents'],
        'currency': value['currency'],
        'selfServiceSelectable': value['selfServiceSelectable'],
        'active': value['active'],
        'entitlements': value['entitlements'] == null ? undefined : ((value['entitlements'] as Array<any>).map(PlanEntitlementUpdateRequestToJSON)),
    };
}

